import { Box, Container, Typography } from "@mui/material"

export const Datenschutz = () => {

    return (
        <Container sx={{ justifyContent: "center", bgcolor: "#FAFAFB", py: 5 }}>
            <Box>
                <Typography variant="h6"><b>1. Name und Kontaktdaten des für die Verarbeitung Verantwortlichen</b></Typography><br />

                Diese Datenschutz-Information gilt für die Datenverarbeitung durch:<br />

                Verantwortliche: <b>Ondilytics UG (haftungsbeschränkt)</b>, g. v. d. d. Onur Özcan<br />
                E-Mail: Ondilytics@gmail.com<br /><br />

                Einen betrieblichen Datenschutzbeauftragten gibt es nicht, da weniger als zehn Personen beschäftigt sind.<br /><br />
            </Box>
            <Box textAlign={"justify"}>
                <Typography variant="h6"><b>2. Erhebung und Speicherung personenbezogener Daten sowie Art und Zweck von deren Verwendung</b></Typography><br />

                Beim Aufrufen unserer Website <a href="www.kanzlei-imrecht.de">www.kanzlei-imrecht.de</a> werden durch den auf Ihrem Endgerät zum Einsatz kommenden Browser
                automatisch Informationen an den Server unserer Website gesendet. Diese Informationen werden temporär in einem sog. Logfile gespeichert.
                Folgende Informationen werden dabei ohne Ihr Zutun erfasst und bis zur automatisierten Löschung gespeichert:<br />
                <ul>
                    <li>IP-Adresse des anfragenden Rechners,</li>
                    <li>Datum und Uhrzeit des Zugriffs,</li>
                    <li>Name und URL der abgerufenen Datei,</li>
                    <li>Website, von der aus der Zugriff erfolgt (Referrer-URL),</li>
                    <li>verwendeter Browser und ggf. das Betriebssystem Ihres Rechners sowie der Name Ihres Access-Providers.</li>
                </ul>

                Die genannten Daten werden durch uns zu folgenden Zwecken verarbeitet:
                <ul>
                    <li>Gewährleistung eines reibungslosen Verbindungsaufbaus der Website,</li>
                    <li>Gewährleistung einer komfortablen Nutzung unserer Website,</li>
                    <li>Auswertung der Systemsicherheit und -stabilität sowie</li>
                    <li>zu weiteren administrativen Zwecken.</li>
                </ul>

                Die Rechtsgrundlage für die Datenverarbeitung ist Art. 6 Abs. 1 S. 1 lit. f DSGVO. Unser berechtigtes Interesse
                folgt aus oben aufgelisteten Zwecken zur Datenerhebung. In keinem Fall verwenden wir die erhobenen Daten zu dem Zweck, Rückschlüsse auf Ihre Person zu ziehen.

                Darüber hinaus setzen wir beim Besuch unserer Website Cookies sowie Analysedienste ein. Nähere Erläuterungen
                dazu erhalten Sie unter den Ziff. 4 und 5 dieser Datenschutzerklärung.<br /><br />
            </Box>

            <Box textAlign={"justify"}>
                <Typography variant="h6"><b>3. Weitergabe von Daten</b></Typography><br />

                Eine Übermittlung Ihrer persönlichen Daten an Dritte zu anderen als den im Folgenden aufgeführten Zwecken findet nicht statt.<br />

                Wir geben Ihre persönlichen Daten nur an Dritte weiter, wenn:
                <ul>
                    <li>Sie Ihre nach Art. 6 Abs. 1 S. 1 lit. a DSGVO ausdrückliche Einwilligung dazu erteilt haben,</li>
                    <li>die Weitergabe nach Art. 6 Abs. 1 S. 1 lit. f DSGVO zur Geltendmachung, Ausübung oder Verteidigung
                        von Rechtsansprüchen erforderlich ist und kein Grund zur Annahme besteht, dass Sie ein überwiegendes
                        schutzwürdiges Interesse an der Nichtweitergabe Ihrer Daten haben,</li>
                    <li>für den Fall, dass für die Weitergabe nach Art. 6 Abs. 1 S. 1 lit. c DSGVO eine gesetzliche Verpflichtung besteht, sowie</li>
                    <li>dies gesetzlich zulässig und nach Art. 6 Abs. 1 S. 1 lit. b DSGVO für die Abwicklung von Vertragsverhältnissen mit Ihnen erforderlich ist.</li>
                </ul>
                <br />
            </Box>
            <Box textAlign={"justify"}>
                <Typography variant="h6"><b>4. Cookies</b></Typography><br />

                Wir setzen auf unserer Seite Cookies ein. Hierbei handelt es sich um kleine Dateien,
                die Ihr Browser automatisch erstellt und die auf Ihrem Endgerät (Laptop, Tablet, Smartphone o.ä.)
                gespeichert werden, wenn Sie unsere Seite besuchen. Cookies richten auf Ihrem Endgerät keinen
                Schaden an, enthalten keine Viren, Trojaner oder sonstige Schadsoftware.<br />

                In dem Cookie werden Informationen abgelegt, die sich jeweils im Zusammenhang mit dem spezifisch
                eingesetzten Endgerät ergeben. Dies bedeutet jedoch nicht, dass wir dadurch unmittelbar Kenntnis
                von Ihrer Identität erhalten.<br />

                Der Einsatz von Cookies dient einerseits dazu, die Nutzung unseres Angebots für Sie angenehmer zu
                gestalten. So setzen wir sogenannte Session-Cookies ein, um zu erkennen, dass Sie einzelne Seiten
                unserer Website bereits besucht haben. Diese werden nach Verlassen unserer Seite automatisch gelöscht.<br />

                Darüber hinaus setzen wir ebenfalls zur Optimierung der Benutzerfreundlichkeit temporäre Cookies ein, die
                für einen bestimmten festgelegten Zeitraum auf Ihrem Endgerät gespeichert werden. Besuchen Sie unsere Seite
                erneut, um unsere Dienste in Anspruch zu nehmen, wird automatisch erkannt, dass Sie bereits bei uns waren
                und welche Eingaben und Einstellungen Sie getätigt haben, um diese nicht noch einmal eingeben zu müssen.<br />

                Zum anderen setzten wir Cookies ein, um die Nutzung unserer Website statistisch zu erfassen und zum Zwecke
                der Optimierung unseres Angebotes für Sie auszuwerten (siehe Ziff. 5). Diese Cookies ermöglichen es uns, bei
                einem erneuten Besuch unserer Seite automatisch zu erkennen, dass Sie bereits bei uns waren. Diese Cookies
                werden nach einer jeweils definierten Zeit automatisch gelöscht.<br />

                Die durch Cookies verarbeiteten Daten sind für die genannten Zwecke zur Wahrung unserer berechtigten
                Interessen sowie der Dritter nach Art. 6 Abs. 1 S. 1 lit. f DSGVO erforderlich.<br />

                Die meisten Browser akzeptieren Cookies automatisch. Sie können Ihren Browser jedoch so konfigurieren,
                dass keine Cookies auf Ihrem Computer gespeichert werden oder stets ein Hinweis erscheint, bevor ein
                neuer Cookie angelegt wird. Die vollständige Deaktivierung von Cookies kann jedoch dazu führen, dass Sie
                nicht alle Funktionen unserer Website nutzen können.<br /><br />
            </Box>
            <Box textAlign={"justify"}>
                <Typography variant="h6"><b>5. Betroffenenrechte</b></Typography><br />

                Sie haben das Recht:
                <ul>
                    <li>gemäß Art. 15 DSGVO Auskunft über Ihre von mir verarbeiteten personenbezogenen Daten zu verlangen.
                        Insbesondere können Sie Auskunft über die Verarbeitungszwecke, die Kategorie der personenbezogenen
                        Daten, die Kategorien von Empfängern, gegenüber denen Ihre Daten offengelegt wurden oder werden,
                        die geplante Speicherdauer, das Bestehen eines Rechts auf Berichtigung, Löschung, Einschränkung
                        der Verarbeitung oder Widerspruch, das Bestehen eines Beschwerderechts, die Herkunft ihrer Daten,
                        sofern diese nicht bei uns erhoben wurden, sowie über das Bestehen einer automatisierten
                        Entscheidungsfindung einschließlich Profiling und ggf. aussagekräftigen Informationen zu deren
                        Einzelheiten verlangen;</li>
                    <li>gemäß Art. 16 DSGVO unverzüglich die Berichtigung unrichtiger oder Vervollständigung Ihrer bei uns
                        gespeicherten personenbezogenen Daten zu verlangen;</li>
                    <li>gemäß Art. 17 DSGVO die Löschung Ihrer bei mir gespeicherten personenbezogenen Daten zu verlangen,
                        soweit nicht die Verarbeitung zur Ausübung des Rechts auf freie Meinungsäußerung und Information,
                        zur Erfüllung einer rechtlichen Verpflichtung, aus Gründen des öffentlichen Interesses oder zur
                        Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen erforderlich ist;</li>
                    <li>gemäß Art. 18 DSGVO die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen,
                        soweit die Richtigkeit der Daten von Ihnen bestritten wird, die Verarbeitung unrechtmäßig ist, Sie
                        aber deren Löschung ablehnen und wir die Daten nicht mehr benötigen, Sie jedoch diese zur Geltendmachung,
                        Ausübung oder Verteidigung von Rechtsansprüchen benötigen oder Sie gemäß Art. 21 DSGVO Widerspruch
                        gegen die Verarbeitung eingelegt haben;</li>
                    <li>gemäß Art. 20 DSGVO Ihre personenbezogenen Daten, die Sie mir bereitgestellt haben, in einem strukturierten,
                        gängigen und maschinenlesebaren Format zu erhalten oder die Übermittlung an einen anderen Verantwortlichen zu verlangen;</li>
                    <li>gemäß Art. 7 Abs. 3 DSGVO Ihre einmal erteilte Einwilligung jederzeit gegenüber mir zu widerrufen.
                        Dies hat zur Folge, dass wir die Datenverarbeitung, die auf dieser Einwilligung beruhte,
                        für die Zukunft nicht mehr fortführen dürfen und</li>
                    <li>gemäß Art. 77 DSGVO sich bei einer Aufsichtsbehörde zu beschweren. In der Regel können Sie sich hierfür an die
                        Aufsichtsbehörde Ihres üblichen Aufenthaltsortes oder Arbeitsplatzes oder unseres Kanzleisitzes wenden.</li>
                </ul>
            </Box>
        </Container>
    )
}